import { render } from "./FoodCategoryCreateContainer.vue?vue&type=template&id=52972bbd&ts=true"
import script from "./FoodCategoryCreateContainer.vue?vue&type=script&lang=ts"
export * from "./FoodCategoryCreateContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__